module.exports = __webpack_public_path__ + "img/logo-dark.06943690.png";